// extracted by mini-css-extract-plugin
export default {"reset-password":"styles_reset-password__YEnsy","link":"styles_link__4AenK","icon-link":"styles_icon-link__wyij+"};